module.exports = __webpack_public_path__ + "img/v15.80184fef.jpg";